import { Box, Typography } from '@mui/material';
import React from 'react';
import { AssetItemActions } from '../../shared/AssetItemActions';
import type { PreferenceCardItem } from './preference-card.types';

export type { PreferenceCardItem };

export interface AssetRowProps {
  item: PreferenceCardItem;
  onQuantityChange: (id: string, delta: number) => void;
  onNoteClick: (id: string, note: string) => void;
  onDelete: (id: string) => void;
}

export const AssetRow: React.FC<AssetRowProps> = ({ item, onQuantityChange, onNoteClick, onDelete }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.75 }}>
    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, mr: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {item.name}
    </Typography>
    <AssetItemActions
      id={item.catalogItemId}
      quantity={item.quantity}
      note={item.note}
      onQuantityChange={onQuantityChange}
      onNoteClick={onNoteClick}
      onDelete={onDelete}
    />
  </Box>
);
